/**
 * ⑧ VALUE CHAIN — WITH DRILL-DOWN
 * UC-06: Scope3Estimator, UC-07: SupplierCampaigns, UC-21: CSDDDScreening
 */
import { useState, useEffect } from "react";
import { C, api, post, patch, Btn, Card, Label, Val, Input, Badge, Err, MetricBar, Loader,
         Breadcrumb, DrillRow, DetailPanel, TabBar, HistoryTab, EmptyState, KPICard, LinkedEntity } from "./shared";

// ═══ UC-06: SCOPE 3 ESTIMATOR ═══
export function Scope3Estimator() {
  const [items,setItems]=useState([{description:"IT Services",amount:250000,currency:"EUR"}]);
  const [result,setResult]=useState(null); const [loading,setLoading]=useState(false);
  const est=async()=>{setLoading(true);try{setResult(await post("/ai/scope3/estimate",{spend_data:items,method:"spend_based"}));}catch(e){}setLoading(false);};
  return (<div data-testid="scope3-estimator-panel"><Label>Spend Items</Label>
    {items.map((it,i)=>(<div key={i} style={{display:"flex",gap:6,marginBottom:4}}>
      <Input value={it.description} onChange={v=>{const n=[...items];n[i].description=v;setItems(n);}} placeholder="Description" style={{flex:2}}/>
      <Input value={it.amount} onChange={v=>{const n=[...items];n[i].amount=parseFloat(v)||0;setItems(n);}} placeholder="Amount" style={{flex:1}}/>
      <Btn onClick={()=>setItems(items.filter((_,j)=>j!==i))} color={C.red} small>X</Btn></div>))}
    <div style={{display:"flex",gap:6,marginTop:6}}><Btn onClick={()=>setItems([...items,{description:"",amount:0,currency:"EUR"}])} color={C.dim} small>+ Add</Btn>
      <Btn onClick={est} color={C.purple} disabled={loading}>{loading?"...":"Estimate"}</Btn></div>
    {result&&<Card color={C.purple} style={{marginTop:12}}>
      <div style={{display:"flex",gap:12}}><div><Label>Total Scope 3</Label><Val color={C.purple}>{result.total_scope3_tCO2e?.toFixed(1)} tCO2e</Val></div>
        <div><Label>Categories</Label><Val>{result.categories}</Val></div></div>
      {(result.by_category||[]).map((cat,i)=>(<DrillRow key={i} onClick={()=>{}} cols={[cat.category,`${cat.tCO2e?.toFixed(1)} tCO2e`,
        <Badge text={`+/-${cat.uncertainty_pct||25}%`} color={C.amber}/>,cat.method]}/>))}</Card>}
  </div>);
}

// ═══ UC-07: SUPPLIER CAMPAIGNS ═══
export function SupplierCampaigns() {
  const [campaigns,setCampaigns]=useState([]); const [loading,setLoading]=useState(false);
  const [sel,setSel]=useState(null); const [campDet,setCampDet]=useState(null);
  const load=async()=>{try{setCampaigns((await api("/supplier/campaigns")).campaigns||[]);}catch(e){}};
  useEffect(()=>{load();},[]);
  const drillCamp=async(c)=>{setSel(c);setCampDet(null);try{setCampDet(await api(`/supplier/campaigns/${c.campaign_id||c.id}`));}catch(e){}};
  return (<div data-testid="supplier-campaigns-panel">
    <Breadcrumb path={[{label:"Campaigns",onClick:()=>setSel(null)},...(sel?[{label:sel.name}]:[])]}/>
    {!sel&&<>{campaigns.map((c,i)=>(<DrillRow key={i} onClick={()=>drillCamp(c)}
      cols={[<span style={{fontWeight:600}}>{c.name}</span>,c.campaign_type||"—",<Badge text={c.status||"active"} color={c.status==="active"?C.emerald:C.amber}/>]}/>))}
      {campaigns.length===0&&<EmptyState message="No campaigns" action="Create campaign" onAction={()=>{}}/>}</>}
    {sel&&<DetailPanel visible onClose={()=>setSel(null)} title={sel.name} color={C.pink}>
      <div><Label>Type</Label><Val>{sel.campaign_type}</Val></div>
      <div><Label>Description</Label><div style={{fontSize:11,marginTop:4}}>{sel.description||campDet?.description||"—"}</div></div>
      <div style={{marginTop:8}}><Label>Suppliers Targeted</Label><div style={{fontSize:11,color:C.muted}}>{campDet?.supplier_ids?.length||0} suppliers</div></div>
    </DetailPanel>}
  </div>);
}

// ═══ UC-21: CSDDD SCREENING ═══
export function CSDDDScreening() {
  const [suppliers,setSuppliers]=useState([]); const [sel,setSel]=useState(null);
  useEffect(()=>{api("/supplier/suppliers").then(r=>setSuppliers(r.suppliers||[])).catch(()=>{});},[]);
  const drillSup=async(s)=>{setSel(null);try{setSel(await api(`/supplier/suppliers/${s.supplier_id||s.id}`));}catch(e){setSel(s);}};
  return (<div data-testid="csddd-screening-panel">
    <Breadcrumb path={[{label:"CSDDD Screening",onClick:()=>setSel(null)},...(sel?[{label:sel.name}]:[])]}/>
    {!sel&&<>{suppliers.map((s,i)=>(<DrillRow key={i} onClick={()=>drillSup(s)}
      cols={[<span style={{fontWeight:600}}>{s.name}</span>,s.country||"—",<Badge text={s.risk_tier||"unknown"} color={s.risk_tier==="high"?C.red:C.emerald}/>]}/>))}
      {suppliers.length===0&&<EmptyState message="No suppliers"/>}</>}
    {sel&&<DetailPanel visible onClose={()=>setSel(null)} title={sel.name} color={C.pink}>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8}}>
        <div><Label>Country</Label><Val>{sel.country}</Val></div>
        <div><Label>Tier</Label><Val>{sel.tier}</Val></div>
        <div><Label>Risk</Label><Badge text={sel.risk_tier||"—"} color={sel.risk_tier==="high"?C.red:C.emerald}/></div></div>
      <div style={{marginTop:8}}><Label>Contact</Label><div style={{fontSize:11}}>{sel.contact_email}</div></div>
    </DetailPanel>}
  </div>);
}
